import Toast, { POSITION } from 'vue-toastification';
import { useToast } from 'vue-toastification'
import { isObject } from 'lodash';

export default {
    install(app, options) {
        app.use(Toast, {
            position: POSITION.BOTTOM_CENTER,
            timeout: 3000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: true,
            closeButton: "button",
        });

        const toast = useToast();

        app.config.globalProperties.$toast = toast;
        app.config.globalProperties.$toastSuccess = toastSuccess;
        app.config.globalProperties.$toastInfo = toast.info;
        app.config.globalProperties.$toastDefault = toast;

        app.config.globalProperties.$toastWarning = (message) => toast.warning(message, {
            icon: 'uis uis-exclamation-triangle'
        });

        app.config.globalProperties.$toastResponse = (message, status = false) => {
            return !status
                ? toastError(message)
                : toastSuccess(message);
        };

        app.config.globalProperties.$toastError = toastError;
        app.config.globalProperties.$toastException = (error) => {
            let msg = null;

            if(isObject(error)) {
                const { message } = error;

                msg = message;
            }

            if (!msg) {
                msg = '[SYSTEM] Something went wrong. Check your error response.';
            }

            return toastError(msg.toString());
        };

        function toastSuccess(message) {
            return toast.success(message);
        }

        function toastError(message) {
            return toast.error(message, {
                icon: 'uis uis-exclamation-octagon'
            });
        }
    }
}